import {
  Badge,
  Button,
  Carousel,
  Col,
  Empty,
  Form,
  Image,
  Input,
  List,
  Modal,
  PageHeader,
  Progress,
  Row,
  Select,
  Space,
  Table,
  Tooltip,
  Typography,
  Upload,
  message,
} from 'antd';
import React, { useEffect, useState } from 'react';
import { GlobalUtilityStyle, PaginationStyle } from '../container/styled';
import { InboxOutlined } from '@ant-design/icons';
import axios from '../backendServiceWithoutTimeout';
import axiosUpload from '../backendServiceForUpload';
import { MdDelete } from 'react-icons/md';
import Cookies from 'js-cookie';
import { FaFile, FaImage } from 'react-icons/fa6';
import { FaEye } from 'react-icons/fa';
import { BiEditAlt } from 'react-icons/bi';
import './Notes.css';
import { GiNotebook } from 'react-icons/gi';
import AWS from 'aws-sdk';

const S3_BUCKET = 'hls-streaming-classroom';
const REGION = 'ap-south-1';
const ACCESS_KEY = 'AKIA4T4OCFU2JPJX5VW5';
const SECRET_ACCESS_KEY = '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';

const s3 = new AWS.S3({
  endpoint: 'https://hls-streaming-classroom.s3.ap-south-1.amazonaws.com',
  accessKeyId: 'AKIA4T4OCFU2JPJX5VW5',
  secretAccessKey: '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',
  region: 'ap-south-1',
  s3BucketEndpoint: true,
});
// Add after the S3 constants
const PDF_FOLDER = 'pdf';
const IMAGE_FOLDER = 'thumbnails';
const DOCUMENT_FOLDER = 'documents';

// Add this helper function
const getFileTypeFolder = (fileType) => {
  if (fileType.includes('pdf')) return 'pdf';
  if (fileType.includes('image')) return 'thumbnails';
  if (fileType.includes('video')) return 'videos';
  if (fileType.includes('text') || fileType.includes('document')) return 'documents';
  return 'documents'; // default folder
};

const contentStyle = {
  margin: 0,
  height: '700px',
  color: '#000',
  lineHeight: '160px',
  textAlign: 'center',
  background: '#000',
};

const Notes = () => {
  const [form] = Form.useForm();
  const userId = Cookies.get('userId');

  const [isOpen, setIsOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [userData, setUserData] = useState();
  const [fileFile, setFileFile] = useState(null);
  const [courseData, setCourseData] = useState([]);
  const [batchData, setBatchData] = useState([]);
  const [subjectData, setSubjectData] = useState([]);
  const [chapterData, setChapterData] = useState([]);
  const [topicData, setTopicData] = useState([]);
  const [batchesToShow, setbatchesToShow] = useState([]);
  const [subjectsToShow, setsubjectsToShow] = useState([]);
  const [chaptersToShow, setchaptersToShow] = useState([]);
  const [topicsToShow, settopicsToShow] = useState([]);
  const [courseId, setCourseId] = useState(null);
  const [batchId, setBatchId] = useState(null);
  const [subjectId, setSubjectId] = useState(null);
  const [chapterId, setChapterId] = useState(null);
  const [topicId, setTopicId] = useState(null);
  const [pdfFileName, setPDFFileName] = useState('');
  const [pdfFileUploadStatus, setPDFFileUploadStatus] = useState('');
  const [fileReady, setFileReady] = useState(false);
  const [uploadedFileName, setUploadedFileName] = useState('');
  const [fileURL, setFileURL] = useState(null);
  const [imageList, setImageList] = useState([]);
  const [allNotes, setAllNotes] = useState([]);
  const [openDelete, setOpenDelete] = useState(false);
  const [noteToDlt, setNoteToDlt] = useState(null);
  const [uploadPercentage, setUploadPercentage] = useState(0);
  const [showUploadBar, setShowUploadBar] = useState(true);
  const [pdfFiles, setPdfFiles] = useState([]);
  const [pdfUrls, setPdfUrls] = useState([]);
  const [isViewNotesModalOpen, setIsViewNotesModalOpen] = useState(false);
  const [currentNoteLinks, setCurrentNoteLinks] = useState([]);
  const [newNoteFile, setNewNoteFile] = useState(null);
  const [uploadProgress, setUploadProgress] = useState(0);


  // For note data table
  const [noteData, setNoteData] = useState([]);
  const [openMemoryModal, setOpenMemoryModal] = useState(false);
  const [memoryImgArr, setMemoryImgArr] = useState([]);
  const [currNote, setCurrNote] = useState(null);
  const [memoryImgToShow, setMemoryImgToShow] = useState([]);
  const [searchQuery, setSearchQuery] = useState('');

  const fetchData = async () => {
    const data = {
      userId: userId,
    };
    try {
      setLoading(true);
      // Fetch user data
      const response = await axios.post(`/users/formwise-userData`, data);
      const resData = await response.data;
      setUserData(resData);
      setCourseData(resData.user_courses);
      setBatchData(resData.user_batches);
      setSubjectData(resData.user_subjects);
      setChapterData(resData.user_chapters);
      setTopicData(resData.user_topics);
      setLoading(false);

      // Fetch user notes
      const notesResponse = await axios.post(`/notes/get-user-notes`, data);
      const notesData = notesResponse.data;
      setNoteData(notesData);
    } catch (error) { }
  };

  useEffect(() => {
    fetchData();
  }, []);

  /**
   * Display table section
   */

  // Display PDF note
  const handleViewPDF = (noteLink) => {
    window.open(noteLink, '_blank');
  };

  // Open memory modal
  const handleMemoryModalOpen = (text) => {
    const imgArr = text.map((item) => item);
    setMemoryImgArr(imgArr);
    setOpenMemoryModal(true);
  };

  // Close memory modal
  const closeMemoryModal = () => {
    setOpenMemoryModal(false);
  };

  // Carousel fn
  const onChange = (currentSlide) => {
    // console.log(currentSlide);
  };

  // Open edit modal
  const handleEdit = (record) => {
    setCurrNote(record);
    setIsOpen(true);
  };

  // Open delete modal
  const handleDelete = (record) => {
    setNoteToDlt(record._id);
    setOpenDelete(true);
  };

  const closeDeleteModal = () => {
    setOpenDelete(false);
  };

  // Delete Note
  const handleNoteDelete = async () => {
    let data = {
      noteId: noteToDlt,
    };
    try {
      const response = await axios.delete(`/notes/delete-note`, {
        data: data,
        headers: {
          'Content-Type': 'application/json',
        },
      });
      const res = await response.data;
      if (res.statusCode === 201) {
        form.resetFields();
        message.success(response.data.message);
        fetchData();
        closeDeleteModal();
      }
    } catch (error) {
      console.error('Error:', error.response ? error.response.data : error.message);
      message.error(error.message);
    }
  };

  // Function to open View Notes modal
  const showViewNotesModal = (record) => {
    setCurrNote(record)
    setCurrentNoteLinks(record.noteLinks);
    setIsViewNotesModalOpen(true);
  };

  const closeViewNotesModal = () => {
    setIsViewNotesModalOpen(false);
    setCurrentNoteLinks([]);
    setNewNoteFile(null);
    setUploadProgress(0);
  };
  const handleFileUpload = async (file) => {
    const uniqueSuffix = Date.now() + '-' + Math.round(Math.random() * 1e9);
    const fileName = file.name.replace(/\s/g, '') + '_' + uniqueSuffix;

    const params = {
      Bucket: S3_BUCKET,
      Key: fileName,
      Body: file,
      ACL: 'public-read',
      ContentType: file.type,
      ContentDisposition: 'inline',
    };

    try {
      const { Location } = await s3.upload(params).on('httpUploadProgress', (evt) => {
        const calculatedProgress = Math.round((evt.loaded / evt.total) * 100);
        setUploadProgress(calculatedProgress);
      }).promise();

      const fileURL = `https://${S3_BUCKET}.s3.${REGION}.amazonaws.com/${s3Key}/${fileName}`;
      setCurrentNoteLinks([...currentNoteLinks, fileURL]);
      message.success('File uploaded successfully');
    } catch (error) {
      console.error('Error uploading file:', error);
      message.error('Failed to upload file');
    }
  };

  const deleteNoteLink = async (linkToDelete) => {
    try {
      const fileName = linkToDelete.split('/').pop();
      await s3.deleteObject({
        Bucket: S3_BUCKET,
        Key: fileName,
      }).promise();

      setCurrentNoteLinks(currentNoteLinks.filter(link => link !== linkToDelete));
      message.success('File deleted successfully');
    } catch (error) {
      console.error('Error deleting file:', error);
      message.error('Failed to delete file');
    }
  };

  const updateNoteLinks = async () => {
    try {
      if (currentNoteLinks.length === 0) {

        message.error(`Please provide atleast one pdf`);
      } else {
        // Implement the API call to update note links
        // For example:
        await axios.post('/notes/update-note-links', { noteId: currNote._id, noteLinks: currentNoteLinks });
        message.success('Note links updated successfully');
        closeViewNotesModal();
        setCurrentNoteLinks([]);

        fetchData(); // Refresh the data
      }


    } catch (error) {
      console.error('Error updating note links:', error);
      message.error('Failed to update note links');
    }
  };
  const columns = [
    {
      title: 'Title',
      dataIndex: 'title',
      key: 'title',
      render: (text) => (
        <Tooltip title={text}>
          <span
            style={{
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              display: 'block',
              maxWidth: '250px',
              paddingLeft: '5px',
            }}
          >
            {text}
          </span>
        </Tooltip>
      ),
    },
    {
      title: 'Course',
      dataIndex: 'course',
      key: 'course',
      render: (text, record) => (
        <div className="flex items-center justify-start gap-1 flex-wrap">
          <Badge
            size={'default'}
            count={text?.courseName}
            className="text-xs"
            style={{ background: '#865CD3', fontSize: '12px' }}
          />
        </div>
      ),
    },
    {
      title: 'Batch',
      dataIndex: 'batch',
      key: 'batch',
      render: (text, record) => (
        <div className="flex items-center justify-start gap-1 flex-wrap">
          <Badge
            size={'default'}
            count={text?.name}
            className="text-xs"
            style={{ background: '#865CD3', fontSize: '12px' }}
          />
        </div>
      ),
    },
    {
      title: 'Subject',
      dataIndex: 'subject',
      key: 'subject',
      render: (text, record) => (
        <div className="flex items-center justify-start gap-1 flex-wrap">
          <Badge
            size={'default'}
            count={text?.subjectName}
            className="text-xs"
            style={{ background: '#865CD3', fontSize: '12px' }}
          />
        </div>
      ),
    },
    {
      title: 'Chapter',
      dataIndex: 'chapter',
      key: 'chapter',
      render: (text, record) => (
        <div className="flex items-center justify-start gap-1 flex-wrap">
          <Badge
            size={'default'}
            count={text?.chapterName}
            className="text-xs"
            style={{ background: '#865CD3', fontSize: '12px' }}
          />
        </div>
      ),
    },
    // {
    //   title: 'Notes',
    //   dataIndex: 'noteLink',
    //   key: 'noteLink',
    //   render: (text, record) => (
    //     <Tooltip title={`View Notes`}>
    //       <GiNotebook
    //         className="mx-2 w-4 h-4 cursor-pointer text-primary dark:text-white60 hover:text-success dark:hover:text-success"
    //         onClick={() => handleViewPDF(text)}
    //       />
    //     </Tooltip>
    //   ),
    // },
    // {
    //   title: 'Notes',
    //   dataIndex: 'noteLinks',
    //   key: 'noteLinks',
    //   render: (text, record) => (
    //     <Space>
    //       {record.noteLinks.map((link, index) => (
    //         <Tooltip key={index} title={`View Note ${index + 1}`}>
    //           <GiNotebook
    //             className="mx-2 w-4 h-4 cursor-pointer text-primary dark:text-white60 hover:text-success dark:hover:text-success"
    //             onClick={() => handleViewPDF(link)}
    //           />
    //         </Tooltip>
    //       ))}
    //     </Space>
    //   ),
    // },
    {
      title: 'Notes',
      dataIndex: 'noteLinks',
      key: 'noteLinks',
      render: (noteLinks, record) => (
        <Space>
          <Button onClick={() => showViewNotesModal(record)}>
            View Notes
          </Button>
        </Space>
      ),
    },

    {
      title: 'Memory Map Images',
      dataIndex: 'memoryMapImages',
      key: 'memoryMapImages',
      align: 'center',
      render: (text, record) => (
        <div className="flex items-center justify-center">
          <Button type="primary" onClick={() => handleMemoryModalOpen(text)}>
            View Images
          </Button>
        </div>
      ),
    },
    {
      title: 'Action',
      dataIndex: 'action',
      key: 'action',
      align: 'center',
      render: (text, record) => (
        <div className="flex items-center justify-center gap-3 flex-wrap">
          <Tooltip title={`Edit Details`}>
            <BiEditAlt
              className="mx-2 w-4 h-4 cursor-pointer text-primary dark:text-white60 hover:text-success dark:hover:text-success"
              onClick={() => handleEdit(record)}
            />
          </Tooltip>
          <Tooltip title={`Delete Note`}>
            <MdDelete
              color="red"
              className="mx-2 w-4 h-4 cursor-pointer text-primary dark:text-white60 hover:text-success dark:hover:text-success"
              onClick={() => handleDelete(record)}
            />
          </Tooltip>
        </div>
      ),
    },
  ];

  const handleManageNotes = (record) => {
    setCurrentNoteRecord(record);
    setIsManageNotesModalOpen(true);
  };

  const closeManageNotesModal = () => {
    setIsManageNotesModalOpen(false);
  };


  // Handle search query input change
  const onSearchQueryChange = (e) => {
    setSearchQuery(e.target.value);
  };

  // Filter the data based on the search query
  const filteredData = noteData.filter(
    (note) => note.title.toLowerCase().includes(searchQuery.toLowerCase()),
    // note.title.toLowerCase().startsWith(searchQuery.toLowerCase()),
  );

  /**
   * Add / Edit Form section
   */

  // Populate form on edit button
  // useEffect(() => {
  //   if (currNote) {
  //     form.setFieldsValue({
  //       title: currNote?.title,
  //       course: currNote?.course.courseName,
  //       batch: currNote?.batch.name,
  //       subject: currNote?.subject.subjectName,
  //       chapter: currNote?.chapter.chapterName,
  //     });
  //     setPDFFileName(currNote.noteLink);
  //     setFileURL(currNote.noteLink);
  //     setPDFFileUploadStatus('Current file');
  //     setMemoryImgToShow(currNote?.memoryMapImages);
  //     setUploadPercentage(100);
  //   }
  // }, [currNote, form]);
  useEffect(() => {
    if (currNote) {
      form.setFieldsValue({
        title: currNote?.title,
        course: currNote?.course.courseName,
        batch: currNote?.batch.name,
        subject: currNote?.subject.subjectName,
        chapter: currNote?.chapter.chapterName,
      });
      setPDFFileName(currNote.noteLinks.map(link => link.split('/').pop()).join(', '));
      setFileURL(currNote.noteLinks);
      setPdfUrls(currNote.noteLinks)
      setPDFFileUploadStatus('Current files');
      setMemoryImgToShow(currNote?.memoryMapImages);
      setUploadPercentage(100);
    }
  }, [currNote, form]);

  // Open add / edit modal
  const showModal = () => {
    setCurrNote(null);
    setPDFFileName(null);
    setFileURL(null);
    setPDFFileUploadStatus(null);
    form.resetFields();
    setUploadPercentage(0);
    setCourseId(null);
    setBatchId(null);
    setSubjectId(null);
    setChapterId(null);
    setTopicId(null);
    setIsOpen(true);
  };

  // Close add / edit modal
  const closeModal = () => {
    setCourseId(null);
    setsubjectsToShow([]);
    setbatchesToShow([]);
    setchaptersToShow([]);
    settopicsToShow([]);
    setCurrNote(null);
    setIsOpen(false);
  };

  // Trigger batch filter on courseId change
  useEffect(() => {
    form.setFieldValue('batch', null);
    form.setFieldValue('chapter', null);
    form.setFieldValue('topic', null);
    const filteredBatches = batchData.filter((batch) => batch.course === courseId);
    setbatchesToShow(filteredBatches);
  }, [courseId]);

  // Trigger subject filter on courseId change
  useEffect(() => {
    form.setFieldValue('subject', null);
    form.setFieldValue('chapter', null);
    form.setFieldValue('topic', null);
    const currentCourse = courseData.find((course) => course._id === courseId);
    if (currentCourse) {
      const subIdArr = currentCourse.subjects.map((sub) => sub);
      const filteredSubjects = subjectData.filter((sub) => subIdArr.includes(sub._id));
      setsubjectsToShow(filteredSubjects);
    }
  }, [courseId]);

  // Trigger chapter filter on subjectId change
  useEffect(() => {
    form.setFieldValue('chapter', null);
    form.setFieldValue('topic', null);
    const filteredChapters = chapterData.filter((ch) => ch.subject === subjectId);
    setchaptersToShow(filteredChapters);
  }, [subjectId]);

  // Trigger topic filter on chapterId change
  useEffect(() => {
    form.setFieldValue('topic', null);
    const filteredTopics = topicData.filter((tp) => tp.subject === subjectId && tp.chapter === chapterId);
    settopicsToShow(filteredTopics);
  }, [chapterId]);

  // Upload PDF file to s3 bucket
    const handlePDFFileUpload = async (file) => {
      setFileReady(false);
      const uniqueSuffix = Date.now() + '-' + Math.round(Math.random() * 1e9);
      const updatedFileName = file.name.replace(/\s/g, '') + '_' + uniqueSuffix;
  
      // Dynamic folder based on file type
      const folderName = getFileTypeFolder(file.type);
      const s3Key = `${folderName}/${updatedFileName}`;
  
      setUploadedFileName(updatedFileName);
  
      const params = {
        Bucket: S3_BUCKET,
        Key: s3Key, // Changed from just updatedFileName
        Body: file,
        ACL: 'public-read',
        ContentType: file.type,
        ContentDisposition: 'inline',
        CreateBucketConfiguration: {
          LocationConstraint: 'ap-south-1',
        },
      };
  
      try {
        setFileUploadStatus(`Uploading in progress...`);
        setUploadPercentage(0);
  
        s3.upload(params, (err, data) => {
          if (err) {
            console.log(err);
            return;
          }
  
          console.log(`File uploaded successfully. ${data.Location}`);
          const pdfURLReceived = data && data.Location;
          if (pdfURLReceived) {
            // Construct proper URL with folder structure
            const finalURL = `https://${S3_BUCKET}.s3.${REGION}.amazonaws.com/${s3Key}`;
            setFileURL(finalURL);
            message.success('File uploaded successfully');
          } else {
            message.error('Failed to upload file. Please try again');
          }
          setFileUploadStatus(`File uploaded successfully.`);
          setFileReady(true);
        }).on('httpUploadProgress', (progressData) => {
          const calculatedProgress = Math.round((progressData.loaded / progressData.total) * 100);
          setUploadPercentage(calculatedProgress);
        });
      } catch (error) {
        console.error('Error uploading file:', error);
        message.error('Failed to upload file');
      }
    };

  const deleteUploadedFile = async (fileName, fileType = null) => {
    try {
      let folderName;

      // Determine folder based on file type or file extension
      if (fileType) {
        folderName = getFileTypeFolder(fileType);
      } else {
        // Fallback: determine by file extension
        const fileExtension = fileName.split('.').pop().toLowerCase();
        if (fileExtension === 'pdf') {
          folderName = 'pdf';
        } else if (['jpg', 'jpeg', 'png', 'gif', 'webp'].includes(fileExtension)) {
          folderName = 'thumbnails';
        } else if (['mp4', 'avi', 'mkv', 'webm'].includes(fileExtension)) {
          folderName = 'videos';
        } else {
          folderName = 'documents';
        }
      }

      await axios.delete(`/videos/gets3objects/delete-from-s3/${folderName}/${fileName}`);
      message.success(`File deleted successfully, upload a new file`);
    } catch (error) {
      console.error('Error deleting file:', error);
      message.error('Failed to delete file');
    }
  };
  
  // Delete uploaded pdf file from s3 bucket
  const clearUploadedPDFFile = async () => {
    await deleteUploadedFile(uploadedFileName);
    setUploadPercentage(0);
    setPDFFileUploadStatus('');
    setFileURL(null);
    form.setFieldValue('notePDF', null);
    form.setFieldValue('imageURL', null);
    setPDFFileName('');
    setFileFile(null);
  };

  // Delete uploaded pdf file from s3 bucket

  const clearExistingPDFFile = async () => {
    const deletePromises = currNote.noteLinks.map(async (link) => {
      const linkArr = link.split('/');
      const fileKey = linkArr[linkArr.length - 1];
      await deleteUploadedFile(fileKey);
    });

    await Promise.all(deletePromises);

    setUploadPercentage(0);
    setPDFFileUploadStatus('');
    setFileURL(null);
    form.setFieldValue('notePDF', null);
    form.setFieldValue('imageURL', null);
    setPDFFileName('');
    setFileFile(null);
  };

  const extractFileName = (url) => {
    const parts = url.split('/');
    const fullFileName = parts[parts.length - 1];
    const fileNameParts = fullFileName.split('_');
    return fileNameParts[0];
  };
  // handle multiple image upload
  const handleImagesChange = async ({ fileList: newFileList }) => {
    setImageList(newFileList);
  };

  // Edit section - delete memory Image
  const deleteMemoryImage = (urlToRemove) => {
    // if (memoryImgToShow.length <= 1 && imageList.length === 0) {
    //   message.error(`You must have atleast one memory map image`);
    // } else if (memoryImgToShow.length === 0 && imageList.length === 0) {
    //   message.error(`You must have atleast one memory map image`);
    // } else {
    setMemoryImgToShow((prev) => prev.filter((item) => item !== urlToRemove));
    // }
  };

  // Handle form submission
  const handleFormSubmit = async (values) => {
    let memoryMapImages = [];
    imageList.map((item) => memoryMapImages.push(item.originFileObj));

    // Prepare FormData
    const formData = new FormData();
    imageList.forEach((file) => {
      formData.append('memoryMapImages', file.originFileObj); // Append each image file
    });

    // Append other form values
    formData.append('title', values.title);
    formData.append('user', userId);
    formData.append('course', courseId);
    formData.append('batch', batchId);
    formData.append('subject', subjectId);
    formData.append('chapter', chapterId);
    formData.append('topic', topicId ? topicId : '');
    // formData.append('noteLink', fileURL);
    // Append each URL as a separate entry with the same key
    pdfUrls.forEach(url => {
      formData.append('noteLinks[]', url);
    });

    try {
      const response = await axios.post(`/notes/add-new-note`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data', // Important to set the correct content type
        },
        maxBodyLength: Infinity,
        maxContentLength: Infinity,
      });
      const res = await response.data;
      if (res.statusCode === 201) {
        form.setFieldValue('Images', null);
        setFileFile(null);
        setPDFFileName('');
        setPDFFileUploadStatus('');
        setImageList([]);
        form.resetFields();
        message.success(response.data.message);
        fetchData();
        closeModal();
      } else if (res.statusCode === 409) {
        message.error(res.message);
      }
    } catch (error) {
      console.error('Error:', error.response ? error.response.data : error.message);
      message.error(error.message);
    }
  };

  // Handle form submission

  const handleEditFormSubmit = async (values) => {
    let existingImgs = memoryImgToShow.map((item) => item).filter((item) => item !== '');

    const formData = new FormData();
    imageList.forEach((file) => {
      formData.append('memoryMapImages', file.originFileObj);
    });

    formData.append('noteId', currNote._id);
    formData.append('title', values.title);
    formData.append('user', userId);
    formData.append('course', currNote.course._id);
    formData.append('batch', currNote.batch._id);
    formData.append('subject', currNote.subject._id);
    formData.append('chapter', currNote.chapter._id);
    formData.append('topic', currNote.topic._id ? currNote.topic._id : '');

    // Append each noteLink
    pdfUrls.forEach(url => {
      formData.append('noteLinks[]', url);
    });

    formData.append('existingMemoryMapImages', existingImgs);

    try {
      const response = await axios.post(`/notes/update-note`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
        maxBodyLength: Infinity,
        maxContentLength: Infinity,
      });
      const res = await response.data;
      if (res.statusCode === 201) {
        form.setFieldValue('Images', null);
        setFileFile(null);
        setPDFFileName('');
        setPDFFileUploadStatus('');
        setImageList([]);
        setCurrNote(null);
        form.resetFields();
        message.success(response.data.message);
        fetchData();
        closeModal();
      }
    } catch (error) {
      console.error('Error:', error.response ? error.response.data : error.message);
      message.error('Failed to update note');
    }
  };

  return (
    <div>
      <PageHeader
        className="flex items-center justify-between px-8 xl:px-[15px] pt-7 pb-6 sm:pb-[30px] bg-transparent sm:flex-col"
        title=""
      />
      <main className="min-h-[715px] lg:min-h-[580px] px-8 xl:px-[15px] bg-transparent">
        <Row gutter={30}>
          <Col xs={24}>
            <>
              <div className="bg-white dark:bg-white10 m-0 text-theme-gray dark:text-white60 text-[15px] rounded-10 relative p-[25px]">
                <div className="text-dark dark:text-white87 font-medium text-[17px] flex items-center justify-between gap-[15px] sm:justify-left mb-5">
                  <div className="flex items-center justify-between gap-[15px]">
                    <h1 className="mb-0 inline-block text-ellipsis text-[18px] font-semibold sm:text-center">Notes</h1>
                    <Input
                      className="w-[150px]"
                      value={searchQuery}
                      onChange={onSearchQueryChange}
                      placeholder="Search by name..."
                    />
                  </div>
                  <Button
                    onClick={showModal}
                    className="h-[50px] px-6 text-xs font-medium bg-primary-transparent text-primary border-none"
                    transparented
                    type="primary"
                    size="large"
                  >
                    + Add Note
                  </Button>
                </div>
                {/*Display courses list */}
                <div className="mt-0.5">
                  <>
                    <GlobalUtilityStyle>
                      <PaginationStyle>
                        <div className="table-pl-0 hover-tr-none table-pt-15 table-responsive ant-pagination-custom-style [&>div>div>div>ul]:pt-[30px] [&>div>div>div>ul]:mt-[20px] [&>div>div>div>ul]:border-normal dark:[&>div>div>div>ul]:border-white10 [&>div>div>div>ul]:border-t-1 [&>div>div>div>ul]:justify-center">
                          <Table
                            pagination={{ pageSize: 10, showSizeChanger: false }}
                            dataSource={filteredData}
                            columns={columns}
                          />
                        </div>
                      </PaginationStyle>
                    </GlobalUtilityStyle>
                  </>
                </div>
              </div>

              {/* Add new plan Modal */}
              <Modal
                open={isOpen}
                style={{ top: 20 }}
                width={1000}
                title="Add a new note"
                okText="Create"
                cancelText="Cancel"
                onCancel={closeModal}
                onOk={() => {
                  form
                    .validateFields()
                    .then((values) => {
                      if (currNote === null) {
                        // if (imageList.length === 0) {
                        //   message.error(`Please upload atleast one memory-map image`);
                        // } else
                        if (fileReady === true) {
                          handleFormSubmit(values);
                        } else {
                          message.error(`Please wait for file upload to finish`);
                        }
                      } else {
                        // if (fileURL === null || fileURL === '') {
                        //   message.error(`Please wait for file upload to finish`);
                        // } else {
                        //   handleEditFormSubmit(values);
                        // }
                        handleEditFormSubmit(values);
                      }
                    })
                    .catch((info) => {
                      console.log('Validate Failed:', info);
                    });
                }}
              >
                <Form
                  form={form}
                  layout="horizontal"
                  name="form_in_modal"
                  initialValues={{
                    modifier: 'public',
                  }}
                >
                  {/* Enter Name */}
                  <Form.Item
                    name="title"
                    rules={[
                      {
                        required: true,
                        message: 'Please enter title of note',
                      },
                    ]}
                  >
                    <Input autoComplete="off" placeholder="Enter the title of note" />
                  </Form.Item>

                  {/* Select Course */}
                  <Form.Item
                    size={'large'}
                    name="course"
                    rules={[{ required: true, message: 'Please select a course!' }]}
                  >
                    {loading && courseData.length === 0 ? (
                      <Select placeholder="Loading courses..." disabled />
                    ) : courseData.length === 0 ? (
                      <Select placeholder="No courses assigned." disabled />
                    ) : (
                      <Select disabled={currNote !== null} placeholder="Select course" onChange={(e) => setCourseId(e)}>
                        {courseData.map((course) => (
                          <Select.Option key={course.courseName} value={course._id}>
                            {course.courseName}
                          </Select.Option>
                        ))}
                      </Select>
                    )}
                  </Form.Item>

                  {/* Select batch */}
                  <Form.Item
                    size={'large'}
                    name="batch"
                    rules={[{ required: true, message: 'Please select a batch!' }]}
                  >
                    <Select
                      disabled={currNote !== null || batchesToShow.length === 0}
                      placeholder="Select batch"
                      onChange={(e) => setBatchId(e)}
                    >
                      {loading && batchesToShow.length === 0 ? (
                        <Select.Option value="Loading batches..." disabled />
                      ) : batchesToShow.length === 0 ? (
                        <Select.Option value="No batches assigned." disabled />
                      ) : (
                        batchesToShow.map((batch) => (
                          <Select.Option key={batch.name} value={batch._id}>
                            {batch.name}
                          </Select.Option>
                        ))
                      )}
                    </Select>
                  </Form.Item>

                  {/* Select subject */}
                  <Form.Item
                    size={'large'}
                    name="subject"
                    rules={[{ required: true, message: 'Please select a subject!' }]}
                  >
                    <Select
                      disabled={currNote !== null || subjectsToShow.length === 0}
                      placeholder="Select subject"
                      onChange={(e) => setSubjectId(e)}
                    >
                      {loading && subjectsToShow.length === 0 ? (
                        <Select.Option value="Loading subjects..." disabled />
                      ) : subjectsToShow.length === 0 ? (
                        <Select.Option value="No course selected." disabled />
                      ) : (
                        subjectsToShow.map((subject) => (
                          <Select.Option key={subject.subjectName} value={subject._id}>
                            {subject.subjectName}
                          </Select.Option>
                        ))
                      )}
                    </Select>
                  </Form.Item>

                  {/* Select chapter */}
                  <Form.Item
                    size={'large'}
                    name="chapter"
                    rules={[{ required: true, message: 'Please select a chapter!' }]}
                  >
                    <Select
                      disabled={currNote !== null || chaptersToShow.length === 0}
                      placeholder="Select chapter"
                      onChange={(e) => setChapterId(e)}
                    >
                      {loading && chaptersToShow.length === 0 ? (
                        <Select.Option value="Loading chapters..." disabled />
                      ) : chaptersToShow.length === 0 ? (
                        <Select.Option value="No subject selected." disabled />
                      ) : (
                        chaptersToShow.map((chapter) => (
                          <Select.Option key={chapter.chapterName} value={chapter._id}>
                            {chapter.chapterName}
                          </Select.Option>
                        ))
                      )}
                    </Select>
                  </Form.Item>

                  {/* Upload pdf file */}
                  {currNote === null ? <>
                    <Space size={'large'} style={{ display: 'flex', justifyContent: 'start' }} wrap>
                      <Form.Item
                        size="large"
                        name="notePDF"
                        rules={[{ required: fileURL === null ? true : false, message: 'Please upload a pdf file' }]}
                      >
                        <Upload
                          style={{ width: '100%' }}
                          multiple={true}
                          beforeUpload={(file) => {
                            const isPDF = file.type.includes('pdf');
                            if (!isPDF) {
                              message.error('Only PDF files are allowed');
                              return Upload.LIST_IGNORE;
                            }
                            return false; // Prevent auto upload
                          }}
                          onChange={(info) => {
                            setPdfFiles(info.fileList.map(file => file.originFileObj));
                          }}
                          showUploadList={true}
                        >
                          <Button
                            style={{ width: '100%' }}
                            size="large"
                            type="primary"
                            icon={<FaFile />}
                            className="text-sm text-blue-700 gap-2 flex items-center justify-start"
                          >
                            Select pdf files of notes
                          </Button>

                        </Upload>
                      </Form.Item>
                      <Button onClick={() => handlePDFFileUpload(pdfFiles)} disabled={pdfFiles.length === 0}>
                        Upload Selected PDFs
                      </Button>
                      {pdfFileName !== '' && pdfFileUploadStatus == 'File uploaded successfully.' && (
                        <Form.Item size={'large'}>
                          <Space wrap>
                            {pdfFileName ? pdfFileName : ''}
                            {pdfFileName !== '' && (
                              <Button
                                onClick={clearUploadedPDFFile}
                                type="default"
                                size="small"
                                className="bg-red-500 text-white"
                              >
                                Delete
                              </Button>
                            )}
                          </Space>
                        </Form.Item>
                      )}
                      {pdfFileUploadStatus !== '' && (
                        <div className="text-xs text-green-500" style={{ color: 'green' }}>
                          {pdfFileUploadStatus}
                        </div>
                      )}
                    </Space>
                    {/* File upload bar */}
                    <div className="mb-7">{showUploadBar && <Progress percent={uploadPercentage} />}</div>
                  </> : null}



                  {currNote === null && (
                    <Form.Item
                      className="py-2"
                      name="Images"
                      rules={[
                        {
                          required: false,
                          message: 'Please upload atleast one memory map image',
                        },
                      ]}
                    >
                      <Upload
                        name="avatar"
                        fileList={imageList}
                        onChange={handleImagesChange}
                        showUploadList={true}
                        multiple={true}
                        beforeUpload={() => false}
                        accept="image/jpeg,image/png"
                      >
                        <Button
                          style={{ width: '100%' }}
                          size="large"
                          type="primary"
                          icon={<FaImage />}
                          className="text-sm text-blue-700 gap-2 flex items-center justify-start"
                        >
                          Upload memory map images
                        </Button>
                      </Upload>
                    </Form.Item>
                  )}
                  {currNote !== null && (
                    <>
                      <Form.Item
                        className="py-2"
                        name="Images"
                        rules={[
                          {
                            required: memoryImgToShow === 0 ? true : false,
                            message: 'Please upload atleast one memory map image',
                          },
                        ]}
                      >
                        <Upload
                          name="avatar"
                          fileList={imageList}
                          onChange={handleImagesChange}
                          showUploadList={true}
                          multiple={true}
                          beforeUpload={() => false}
                          accept="image/jpeg,image/png"
                        >
                          <Button
                            style={{ width: '100%' }}
                            size="large"
                            type="primary"
                            icon={<FaImage />}
                            className="text-sm text-blue-700 gap-2 flex items-center justify-start"
                          >
                            Upload memory map images
                          </Button>
                        </Upload>
                      </Form.Item>
                      <div className="flex p-2 items-start justify-start gap-2">
                        {memoryImgToShow.map((item, index) => (
                          <div key={index} className="relative border">
                            <MdDelete
                              onClick={() => deleteMemoryImage(item)}
                              className="absolute top-0 right-0 w-4 h-4 left-auto cursor-pointer z-10"
                              color="red"
                            />
                            <img width={200} src={`data:image/png;base64,` + item} alt="memory-image" />
                          </div>
                        ))}
                      </div>
                    </>
                  )}
                </Form>
              </Modal>
            </>
          </Col>
        </Row>
      </main>

      {/* Memory map modal */}
      <Modal open={openMemoryModal} onCancel={closeMemoryModal} footer={null}>
        <Carousel afterChange={onChange} className="py-8">
          {memoryImgArr.length ? (
            memoryImgArr.map((item, index) => (
              <div key={index} className="flex items-center justify-center mb-6">
                <img width={400} src={`data:image/png;base64,` + item} alt="memory-image" />
              </div>
            ))
          ) : (
            <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
          )}
        </Carousel>
      </Modal>

      {/* Delete modal */}
      <Modal title={'Are you sure delete this note?'} open={openDelete} onCancel={closeDeleteModal} footer={null}>
        <div className="flex items-center justify-end gap-2">
          <Button onClick={closeDeleteModal} type={'ghost'}>
            Cancel
          </Button>
          <Button onClick={handleNoteDelete} type={'danger'}>
            Delete
          </Button>
        </div>
      </Modal>

      {/* notes modal */}
      <Modal
        title="Manage Notes"
        open={isViewNotesModalOpen}
        onCancel={closeViewNotesModal}
        footer={[
          <Button key="cancel" onClick={closeViewNotesModal}>
            Cancel
          </Button>,
          <Button key="update" type="primary" onClick={updateNoteLinks}>
            Update Notes
          </Button>,
        ]}
      >
        <Space direction="vertical" style={{ width: '100%' }}>
          {currentNoteLinks.map((link, index) => {
            const fileName = extractFileName(link);
            return (
              <div key={index} className="mb-4">
                <div className='flex justify-between items-center'>
                  <Typography.Link href={link} target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:text-blue-800">
                    {fileName}
                  </Typography.Link>
                  <Button type="primary" danger size='small' onClick={() => deleteNoteLink(link)} className="ml-2">
                    Delete
                  </Button>
                </div>
              </div>
            );
          })}
          <div className='flex justify-between'>
            <div>
              <Upload
                beforeUpload={(file) => {
                  setNewNoteFile(file);
                  return false;
                }}
                fileList={newNoteFile ? [newNoteFile] : []}
              >
                <Button>Select single File</Button>
              </Upload>
            </div>
            <div>
              <Button
                type="primary"
                onClick={() => newNoteFile && handleFileUpload(newNoteFile)}
                disabled={!newNoteFile}
              >
                Upload
              </Button>
            </div>
          </div>
          {uploadProgress > 0 && <Progress percent={uploadProgress} />}
        </Space>
      </Modal>

    </div>
  );
};

export default Notes;
